import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

export interface PageMetadata {
  title: string;
  description: string;
  image: string;
}

@Injectable({ providedIn: 'root' })
export class MetadataService {
  constructor(private metaTagService: Meta, @Inject(DOCUMENT) private doc) { }

  /**
   *
   *
   * @name updateMetadata
   *
   * @param metadata
   * @memberof MetadataService
   */
  updateMetadata(metadata: PageMetadata): void {
    const pageMetadata: PageMetadata = { ...metadata };
    const metaTags: MetaDefinition[] = this.generateMetaDefinitions(pageMetadata);
    metaTags.forEach(tag => {
      this.metaTagService.updateTag(tag);
    });
    this.setCanonicalLink();
  }

  /**
   * @name removeMetadata
   * @description This method removes the desired meta tags
   * @memberof MetadataService
   */
  removeMetadata() {
    this.metaTagService.removeTag('name=\'description\'');
    this.metaTagService.removeTag('name=\'robots\'');
    this.metaTagService.removeTag('name=\'google-site-verification\'');

    this.metaTagService.removeTag('property=\'og:site_name\'');
    this.metaTagService.removeTag('property=\'og:title\'');
    this.metaTagService.removeTag('property=\'og:description\'');
    this.metaTagService.removeTag('property=\'og:url\'');
    this.metaTagService.removeTag('property=\'og:image\'');

    this.metaTagService.removeTag('name=\'twitter:card\'');
    this.metaTagService.removeTag('name=\'twitter:url\'');
    this.metaTagService.removeTag('name=\'twitter:title\'');
    this.metaTagService.removeTag('name=\'twitter:description\'');
    this.metaTagService.removeTag('name=\'twitter:image\'');
  }

  /**
   * @name set canonical link meta tag
   * @description This method set canonical link meta tag
   * @memberof MetadataService
   */
  setCanonicalLink() {
    let link: HTMLLinkElement = this.doc.getElementById('canonicalLink');
    if (link) {
      link.setAttribute('href', `${window.location.href}`);
    } else {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('id', 'canonicalLink');
      link.setAttribute('href', `${window.location.href}`);
      this.doc.head.appendChild(link);
    }
  }

  /**
   *
   *
   * @name generateMetaDefinitions
   * @description this method generates metadefinition from provided page metadata
   * @private
   * @param metadata
   * @returns
   * @memberof MetadataService
   */
  private generateMetaDefinitions(metadata: PageMetadata): MetaDefinition[] {
    return [
      { name: 'description', content: metadata.description || metadata.title },
      { name: 'robots', content: 'noindex, nofollow' },
      { name: 'google-site-verification', content: 'aJGyaaysaMMdvmJqSEMwI0_O8qmh7MeDxxj8-GHIF7E' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: environment.hybrisBaseSite },
      { property: 'og:title', content: metadata.title },
      { property: 'og:description', content: metadata.description || metadata.title },
      { property: 'og:url', content: `${window.location.href}` },
      {
        property: 'og:image', content: metadata.image ?
          metadata.image : `${window.location.origin}/mylist/assets/image/header/Amw_Logo_AG_Site.png`
      },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:url', content: `${window.location.href}` },
      { name: 'twitter:title', content: metadata.title },
      { name: 'twitter:description', content: metadata.description || metadata.title },
      {
        name: 'twitter:image', content: metadata.image ?
          metadata.image : `${window.location.origin}/mylist/assets/image/header/Amw_Logo_AG_Site.png`
      }
    ];
  }
}
